import { render, staticRenderFns } from "./UsedCouponRow.vue?vue&type=template&id=203e8ff8&scoped=true"
import script from "./UsedCouponRow.vue?vue&type=script&lang=js"
export * from "./UsedCouponRow.vue?vue&type=script&lang=js"
import style0 from "./UsedCouponRow.vue?vue&type=style&index=0&id=203e8ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203e8ff8",
  null
  
)

export default component.exports